<template>
  <div>
    <b-row>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.fa_name.$model"
            :state="validateState('fa_name')"
            :disabled="disabled"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام را به صورت صحیح وارد کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام خانوادگی:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.fa_family.$model"
            :state="validateState('fa_family')"
            :disabled="disabled"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام خانوادگی را به صورت صحیح وارد کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام پدر:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.fa_father.$model"
            :disabled="disabled"
            :state="validateState('fa_father')"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام پدر را به صورت صحیح وارد کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
    </b-row>

    <b-row>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام به انگلیسی:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.en_name.$model"
            :state="validateState('en_name')"
            :disabled="disabled"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام به انگلیسی را به صورت صحیح وارد کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام خانوادگی به انگلیسی:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.en_family.$model"
            :state="validateState('en_family')"
            :disabled="disabled"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام خانوادگی به انگلیسی را به صورت صحیح وارد
            کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="نام پدر به انگلیسی:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.en_father.$model"
            :disabled="disabled"
            :state="validateState('en_father')"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >نام پدر به انگلیسی را به صورت صحیح وارد
            کنید</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
    </b-row>

    <b-row>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="کد ملی:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.national_card_number.$model"
            :state="validateState('national_card_number')"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="شماره شناسنامه:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.id_number.$model"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="تلفن همراه:"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.mobile.$model"
            :state="validateState('mobile')"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن تلفن همراه اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="پست الکترونیکی"
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.value.email.$model"
            :state="validateState('email')"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >پست الکترونیکی اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
    </b-row>

    <b-row>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-row>
          <b-col>
            <b-form-group
              id="example-input-group-1"
              label="تلفن ثابت:"
              label-for="example-input-1"
            >
              <b-form-input
                id="example-input-1"
                v-model="$v.value.phone.$model"
                :state="validateState('phone')"
                :disabled="disabled"
              ></b-form-input>
              <b-form-invalid-feedback id="input-1-live-feedback"
                >وارد کردن تلفن ثابت اجباری است</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group
              id="example-input-group-1"
              label="کد شهر:"
              label-for="example-input-1"
            >
              <b-form-input
                id="example-input-1"
                v-model="$v.value.pre_phone.$model"
                :state="validateState('pre_phone')"
                :disabled="disabled"
              ></b-form-input>
              <b-form-invalid-feedback id="input-1-live-feedback"
                >وارد کردن کد شهر اجباری است</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="جنسیت:"
          label-for="example-input-1"
        >
          <MDDropdown
            :disabled="disabled"
            v-bind:group="18"
            v-model="$v.value.mdid18_gender.$model"
          ></MDDropdown>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن جنسیت اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group
          id="example-input-group-1"
          label="تاریخ تولد:"
          label-for="example-input-1"
        >
          <date-picker
            :disabled="disabled"
            required
            v-model="$v.value.birth_date.$model"
            :max="maxDate"
          ></date-picker>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن تاریخ تولد اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </div>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";
import MDDropdown from "../../components/MDDropdown";
import persianDate from "../../helpers/persianDate";
const enchars = (value, vm) => !/[^A-Za-z0-9]/.test(value);
const fachars = (value, vm) => /[^A-Za-z0-9]/.test(value);
const phone = (value, vm) => /\d{5,8}/g.test(value);
const prephone = (value, vm) => /0\d{2}/.test(value);
export default {
  mixins: [validationMixin],
  name: "PersonInfo",
  props: ["value", "disabled", "validateInputswatcher", "readonly"],
  data() {
    return {
      maxDate: "",
    };
  },
  validations: {
    value: {
      id_number: {
      },
      address: {
        fachars,
      },
      email: {
        required,
        email,
      },
      fa_name: {
        fachars,
        required,
        minLength: minLength(3),
      },
      fa_family: {
        fachars,
        required,
        minLength: minLength(3),
      },
      en_name: {
        enchars,
        required,
        minLength: minLength(3),
      },
      en_family: {
        enchars,
        required,
        minLength: minLength(3),
      },
      national_card_number: {
        required,
      },
      mobile: {
        required,
      },
      mdid18_gender: {
        required,
      },
      pre_phone: {
        required,
        prephone,
      },
      phone: {
        required,
        phone,
      },
      postalcode: {
        required,
      },
      fa_father: { fachars, required, minLength: minLength(3) },
      en_father: { enchars, required, minLength: minLength(3) },
      birth_date: { required },
      //   password: {
      //     required,
      //     minLength: minLength(3)
      //   }
    },
  },
  watch: {
    value: function(newval, oldval) {
      //this.form = newval;
    },
    validateInputswatcher: function(newval, oldval) {
      this.validateInputs();
    },
  },
  methods: {
    persianChars(event) {
      var validChars = "اآبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیي";
      if (
        validChars.indexOf(event.key) < 0 &&
        event.key != "Shift" &&
        event.key != "Backspace" &&
        event.key != " " &&
        event.key != "Tab"
      ) {
        event.preventDefault();
      }
    },
    engelishChars(event) {
      var validChars = "abcdefghijklmnopqrstuvwxyz";
      if (
        validChars.indexOf(event.key) < 0 &&
        validChars.toUpperCase().indexOf(event.key) < 0 &&
        event.key != "Shift" &&
        event.key != "Backspace" &&
        event.key != " " &&
        event.key != "Tab"
      ) {
        event.preventDefault();
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    validateInputs() {
      this.$v.value.$touch();
    },
  },
  created() {
    //this.form = this.value;
    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();
    var c = new Date(year - 18, month, day);
    this.maxDate = persianDate.getDateByFormat(c);
  },
  components: {
    MDDropdown,
  },
};
</script>
